import { AlertChannel, AlertPerWeek, CasesPerWeek } from './resume_interfaces';

export class LineCharData {
  labels: string[] = [];
  created: number[] = [];
  finished: number[] = [];

  constructor(data: CasesPerWeek[]) {
    data.forEach((item: CasesPerWeek) => {
      this.labels.push(item.week);
      this.created.push(item.created);
      this.finished.push(item.finished);
    });
  }
}
export class LineCharDataAlert {
  labels: string[] = [];
  initial: number[] = [];
  proceed: number[] = [];
  refused: number[] = [];
  finished: number[] = [];

  constructor(data: AlertPerWeek[]) {
    data.forEach((item: AlertPerWeek) => {
      this.labels.push(item.week);
      this.initial.push(item.initial);
      this.proceed.push(item.proceed);
      this.refused.push(item.refused);
      this.finished.push(item.finished);
    });
  }
}
export class BarCharDataAlertChannel {
  labels: string[] = [];
  amount: number[] = [];
  constructor(data: AlertChannel) {
    this.labels = data.labels;
    this.amount = data.amount;
  }
}
